"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navigation = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Fab = _interopRequireDefault(require("@mui/material/Fab"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Grow = _interopRequireDefault(require("@mui/material/Grow"));
var _CheckCircle = _interopRequireDefault(require("@mui/icons-material/CheckCircle"));
var _reactI18next = require("react-i18next");
var _Place = _interopRequireDefault(require("@mui/icons-material/Place"));
var _styles = require("@mui/material/styles");
var Navigation = function Navigation(_ref) {
  var type = _ref.type,
    onClick = _ref.onClick,
    title = _ref.title;
  var theme = (0, _styles.useTheme)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    scrollState = _useState2[0],
    setScrollState = _useState2[1];

  // TODO: Update depending on the resolution/aspect ratio
  var _useState3 = (0, _react.useState)({
      position: 'fixed',
      right: 16,
      bottom: 'auto',
      zIndex: '1300',
      top: "".concat(window.innerHeight - 128, "px")
    }),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 1),
    containerStyle = _useState4[0];

  // TODO: Update depending on the resolution/aspect ratio
  var _useState5 = (0, _react.useState)(30),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 1),
    scrollOfset = _useState6[0];
  var ref = (0, _react.useRef)(null);
  var textRef = (0, _react.useRef)(null);
  var handler = function handler() {
    if (window.scrollY > scrollOfset) {
      setScrollState(false);
      if (textRef !== null && textRef !== void 0 && textRef.current) {
        textRef.current.style.display = 'none';
      }
    } else {
      if (textRef !== null && textRef !== void 0 && textRef.current) {
        textRef.current.style.display = 'block';
      }
      setScrollState(true);
    }
  };
  (0, _react.useEffect)(function () {
    /* eslint-disable no-restricted-globals */
    addEventListener('scroll', handler);
  }, []);
  var renderIcon = function renderIcon(type) {
    switch (type) {
      case 'choose':
        return /*#__PURE__*/_react.default.createElement(_Place.default, {
          role: "image",
          sx: {
            color: theme.palette.text.primary
          }
        });
      case 'done':
        return /*#__PURE__*/_react.default.createElement(_CheckCircle.default, {
          role: "image",
          sx: {
            color: theme.palette.text.primary
          }
        });
      default:
        return /*#__PURE__*/_react.default.createElement(_CheckCircle.default, {
          role: "image",
          sx: {
            color: theme.palette.text.primary
          }
        });
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    ref: ref,
    sx: containerStyle
  }, /*#__PURE__*/_react.default.createElement(_Fab.default, {
    className: "app-floating",
    variant: "extended",
    "aria-label": t(title),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Grow.default, {
    in: scrollState
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "subtitle2",
    sx: {
      ml: 1,
      mr: 1,
      color: theme.palette.text.primary
    },
    ref: textRef
  }, t(title))), renderIcon(type)));
};
exports.Navigation = Navigation;